import React, { useState } from 'react';
import { AlertCircle, X, Mail } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import './EmailVerificationBanner.css';

function EmailVerificationBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);
  const [message, setMessage] = useState('');

  if (!user || user.isEmailVerified || dismissed) {
    return null;
  }

  const handleResend = async () => {
    setResending(true);
    setMessage('');

    try {
      const response = await axios.post('/api/auth/resend-verification', {
        email: user.email
      });
      setMessage(response.data.message);
      setTimeout(() => setMessage(''), 5000);
    } catch (error) {
      setMessage(error.response?.data?.error || 'Failed to resend email');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="verification-banner">
      <div className="verification-banner-content">
        <AlertCircle size={20} />
        <div className="verification-banner-text">
          <strong>Please verify your email address</strong>
          <span>Check your inbox for a verification link</span>
        </div>
        <button 
          className="verification-banner-btn"
          onClick={handleResend}
          disabled={resending}
        >
          <Mail size={16} />
          {resending ? 'Sending...' : 'Resend Email'}
        </button>
        <button 
          className="verification-banner-close"
          onClick={() => setDismissed(true)}
        >
          <X size={18} />
        </button>
      </div>
      {message && (
        <div className="verification-banner-message">
          {message}
        </div>
      )}
    </div>
  );
}

export default EmailVerificationBanner;
